export enum MessageDirection {
    Sent = 'sent',
    Received = 'received',
}
